import { hide, show } from '@ebay/nice-modal-react'
import { Button, Menu, MenuItem, Stack, Typography, styled } from '@mui/material'
import React, { useState } from 'react'
import { useWeb3Modal } from '@web3modal/react'
import Image from 'next/image'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { useAccount, useNetwork, useSwitchNetwork } from 'wagmi'
import BitcoinWalletConnectDialog from '../../BitcoinConnectDialog'
import { useWallet } from '../../WalletContext'

import TokenLogo from '../../TokenLogo'
import bitcoinSvg from '@/assets/imgs/bitcoin.svg'
import { CHAIN_INFO, SUPPORTED_CHAIN } from '@/constants'

const Label = styled(Typography)`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
`

const ConnectWalletButton = () => {
  const { walletType, setCurrentSelectedWallet, isConnected } = useWallet()

  const { switchNetwork } = useSwitchNetwork()
  const { isConnected: isEvmWalletConnected } = useAccount()

  const { chain } = useNetwork()

  const { open: openWeb3Modal, setDefaultChain } = useWeb3Modal()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isMenuOpen = Boolean(anchorEl)
  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const closeMenu = () => {
    setAnchorEl(null)
  }

  const connectBtcWallet = () => {
    show(BitcoinWalletConnectDialog, {
      onConnect: () => {
        setCurrentSelectedWallet('Btc')
        hide(BitcoinWalletConnectDialog)
      },
    })
    closeMenu()
  }

  const connectEvmWallet = (chainId: number) => {
    setDefaultChain(CHAIN_INFO[chainId])

    if (isEvmWalletConnected) {
      switchNetwork(chainId)
    } else {
      openWeb3Modal()
    }

    setCurrentSelectedWallet('Evm')
    closeMenu()
  }

  return (
    <>
      <Button
        color="secondary"
        variant="outlined"
        onClick={openMenu}
        sx={{
          width: 180,
          borderColor: isMenuOpen ? '#BFFF0B' : 'rgba(255, 255, 255, 0.2)',
        }}
      >
        {isConnected ? (
          walletType === 'Btc' ? (
            <Stack direction="row" spacing={8} sx={{ alignItems: 'center' }}>
              <Image src={bitcoinSvg} width={24} height={24} alt="bitcoin" />
              <Label>Bitcoin</Label>
              <ExpandMoreIcon sx={{ color: '#fff', ml: 6 }} />
            </Stack>
          ) : (
            <Stack direction="row" spacing={8} sx={{ alignItems: 'center' }}>
              {!chain?.unsupported ? (
                <>
                  <Image src={SUPPORTED_CHAIN?.[chain?.id]?.logoSrc} width={24} height={24} alt="logo" />
                  <Label>
                    {SUPPORTED_CHAIN?.[chain?.id]?.shortLabel || SUPPORTED_CHAIN?.[chain?.id]?.abbreviation}
                  </Label>
                </>
              ) : (
                <>
                  <WarningAmberIcon color="error" />
                  <Label>Error Network</Label>
                </>
              )}
              <ExpandMoreIcon sx={{ color: '#fff', ml: 6 }} />
            </Stack>
          )
        ) : (
          <Label>Connect Wallet</Label>
        )}
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={closeMenu}
        MenuListProps={{ sx: { py: 0 } }}
        slotProps={{
          paper: { sx: { backgroundImage: 'none', borderRadius: 'unset', border: '1px solid #bfff0b', width: 180 } },
        }}
      >
        <MenuItem onClick={connectBtcWallet}>
          <Image src={bitcoinSvg} width={24} height={24} alt="logo" style={{ marginRight: '8px' }} />
          Bitcoin
        </MenuItem>

        {Object.values(SUPPORTED_CHAIN).map((chain) => (
          <MenuItem
            key={chain.id}
            onClick={() => {
              connectEvmWallet(chain.id)
            }}
          >
            <TokenLogo src={chain.logoSrc} alt={chain.name} style={{ marginRight: '8px' }} size={24} />
            {chain?.shortLabel || chain.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default ConnectWalletButton
